import { inject } from '@angular/core';
import { CourseSearchScrollerService } from '../services/course-search-scroller.service';

export const resetScrollerGuard = () => {
	const scrollerSrv = inject(CourseSearchScrollerService);
	scrollerSrv.resetInitialLoad();
	return true;
};
